"use client";

import { useEffect } from "react";
import { ensureSessionId } from "@/shared/http/session-id";

/**
 * Cria a sessão de convidado no primeiro acesso. Idempotente: a promise
 * singleton do helper absorve o double-invoke do Strict Mode.
 */
export function SessionInit() {
    useEffect(() => {
        ensureSessionId().catch((error: unknown) => {
            // Sem sessão a API vai falhar, mas derrubar a UI aqui não ajuda.
            console.warn("[session]", error);
        });
    }, []);

    return null;
}
